import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IconButton } from 'sidecar-components'

/**
 * An icon button that navigates back to the previous page in history. It's
 * mainly used in mobile headers that are inside of a native app webview that
 * has no back button.
 *
 * @returns {JSX.Element} IconButton that navigates back
 */
export const BackButton = () => {
  const navigate = useNavigate()
  const handleGoBack = () => {
    navigate(-1)
  }

  // Hide the button if there is no history to go back to
  const showBackButton = window.history.length > 1

  return showBackButton ? (
    <IconButton
      label="Back"
      icon="back"
      onClick={handleGoBack}
      testId="btn_navigateBack"
    />
  ) : null
}
